import React from "react";
import CountUp from "react-countup";
import SVGRenderer from "../SVGRenderer";
import LazyImage from "components/elements/LazyImage/LazyImage";
import SmartLink from "components/SmartLink";
import Button from "components/elements/Button/Button";

import styles from "./Card.module.scss";

/**
 * Variant Card layout with different styling and arrangement
 * 
 * @param {Object} props - Component properties (same as standard Card)
 */
const CardVariant = React.forwardRef(({ 
	inView,
	title, 
	svg, 
	lead, 
	desc, 
	cta_text, 
	cta_link, 
	image, 
	image_alt, 
	bg_image, 
	bg_image_alt, 
	bg_color, 
	className = "", 
	theme, 
	count_up
}, ref) => {
	return (
		<div
			ref={ref}
			{...(theme ? { "data-bs-theme": theme } : {})}
			style={bg_color && { backgroundColor: bg_color }}
			className={`${styles.CardVariant} card h-100 rounded-4 shadow border-0 position-relative overflow-hidden ${className} ${bg_image && "bg-transparent"}`}>
			{image && (
				<div className="position-relative" style={{ height: "180px" }}>
					<LazyImage
						src={image}
						alt={image_alt || title}
						className="card-img-top"
						fill_mode="cover"
					/>
				</div>
			)}
			<div className="card-body p-4 d-flex flex-column">
				{svg && (
					<div className="mb-3 svg-wrapper">
						<SVGRenderer svgString={svg} />
					</div>
				)}
				{inView && count_up && (
					<CountUp
						className="count-up fs-1 fw-bold mb-3"
						end={count_up}
						duration={5}
						separator="."
					/>
				)}
				{title && <h3 className="card-title fs-4 fw-bold mb-2">{title}</h3>}
				{lead && <p className="lead mb-3">{lead}</p>}
				
				{desc && (
					<div 
						className="card-text mb-4"
						dangerouslySetInnerHTML={{ __html: desc }}></div>
				)}
				
				<div className="mt-auto">
					{cta_text && cta_link && (
						<SmartLink 
							to={cta_link}
							className="text-decoration-none">
							<Button
								size={"md"}
								variant={"outline-primary"}
								className="w-100"
								letterCase="uppercase">
								{cta_text}
							</Button>
						</SmartLink>
					)}
				</div>
			</div>
			{bg_image && (
				<img
					src={bg_image}
					alt={bg_image_alt || ""}
					className="position-absolute w-100 h-100"
					style={{
						objectFit: "cover",
						filter: "blur(8px)",
						opacity: 0.15,
						zIndex: -1,
						top: 0,
						left: 0,
					}}
					aria-hidden="true"
				/>
			)}
		</div>
	);
});

export default CardVariant;
